import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastsComponent } from './toasts/toasts.component';
import { NotificationAnimationType, Options } from './definitions';
import { NotificationsService, DEFAULT_ICONS } from './NotificationsService';
import { ToastComponent } from './toast/toast.component';
export const OPTIONS = new InjectionToken<Options>('options');
export const DEFAULT_OPTIONS: Options = {
  position: ['bottom', 'right'],
  timeOut: 0,
  showProgressBar: true,
  pauseOnHover: true,
  lastOnBottom: true,
  clickToClose: true,
  clickIconToClose: false,
  maxLength: 0,
  maxStack: 8,
  preventDuplicates: false,
  preventLastDuplicates: false,
  theClass: '',
  rtl: false,
  animate: NotificationAnimationType.FromRight,
  icons: DEFAULT_ICONS,
};
export function optionsFactory(options) {
  return {
    ...DEFAULT_OPTIONS,
    ...options,
  };
}
@NgModule({
  declarations: [ToastsComponent, ToastComponent],
  imports: [CommonModule],
  exports: [ToastsComponent],
})
export class ToastModule {
  static forRoot(options: Options = {}): ModuleWithProviders<ToastModule> {
    return {
      ngModule: ToastModule,
      providers: [
        NotificationsService,
        {
          provide: OPTIONS,
          useValue: options,
        },
        {
          provide: 'options',
          useFactory: optionsFactory,
          deps: [OPTIONS],
        },
      ],
    };
  }
}
